<div class="horizinns-container center">
    <mat-card class="horizinns-card">
        <mat-card-content>
            <img src="/assets/images/logo_full_900.png" style="width:40%;" class="main-logo" alt="Horizinns logo" />
            <h1>😳 Page Not Found</h1>
            <h3>Sorry, we couldn't find that page.</h3>
            <button mat-raised-button color="accent" routerLink="/">
                <mat-icon matPrefix>home</mat-icon>
                Home
            </button>
        </mat-card-content>
    </mat-card>
</div>